// extracted by mini-css-extract-plugin
export default {"IconContainer":"FavoriteIconPicker_IconContainer__NoO9C","IconPickerPopup":"FavoriteIconPicker_IconPickerPopup__heyH3","IconHover":"FavoriteIconPicker_IconHover__hhDKb"};